// extracted by mini-css-extract-plugin
export var animationContainer = "_g8-0";
export var footer = "_g8-1";
export var gray = "_g8-2";
export var lineItem = "_g8-3";
export var lineItemImage = "_g8-4";
export var lineItemInfo = "_g8-5";
export var lineItemText = "_g8-6";
export var lineItems = "_g8-7";
export var modalContent = "_g8-8";
export var options = "_g8-9";
export var orderName = "_g8-a";
export var refundAmount = "_g8-b";